export const SET: "selection/SET" = "selection/SET";
export const TOGGLE: "selection/TOGGLE" = "selection/TOGGLE";
export const CLEAR: "selection/CLEAR" = "selection/CLEAR";
export const PRUNE: "selection/PRUNE" = "selection/PRUNE";
